import { AlertTriangle } from "lucide-react";
import { useId, useRef } from "react";
import { createPortal } from "react-dom";
import { useDialogFocus } from "../lib/accessibility";
import { Button } from "./Button";
import { ProgressBar } from "./ProgressBar";

interface ConfirmDialogProps {
  open: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  intent?: "primary" | "danger";
  loading?: boolean;
  progressLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export function ConfirmDialog({ open, title, message, confirmLabel = "确认", intent = "danger", loading, progressLabel, onConfirm, onCancel }: ConfirmDialogProps) {
  const rootRef = useRef<HTMLElement>(null);
  const titleId = useId();
  const messageId = useId();
  const dismiss = () => { if (!loading) onCancel(); };
  useDialogFocus(open, rootRef, dismiss);

  if (!open) return null;
  return createPortal(
    <div className="overlay overlay--center" role="presentation" onMouseDown={dismiss}>
      <section ref={rootRef} className="dialog" role="alertdialog" aria-modal="true" aria-labelledby={titleId} aria-describedby={messageId} tabIndex={-1} onMouseDown={(event) => event.stopPropagation()}>
        <div className="dialog__icon"><AlertTriangle /></div>
        <h2 id={titleId}>{title}</h2>
        <p id={messageId}>{message}</p>
        {loading && progressLabel ? <div className="dialog__progress"><small>{progressLabel}</small><ProgressBar value={72} /></div> : null}
        <footer>
          <Button onClick={dismiss} disabled={loading} data-autofocus>取消</Button>
          <Button variant={intent} onClick={onConfirm} loading={loading}>{confirmLabel}</Button>
        </footer>
      </section>
    </div>,
    document.body,
  );
}
